module.exports = __webpack_public_path__ + "static/media/mail.f4e4314a.svg";